import I18n from '@utils/i18n.utils';

export namespace NumberExt {
  export const bytesFormatter = (value: number) => {
    const kb = value / 1024;
    if (kb < 1000)
      return I18n.t('global.KB', {kb: kb.toFixed(0)});

    const mb = kb / 1024;
    return I18n.t('global.MB', {mb: mb.toFixed(1)});
  };

  export const round = (value, places, isInvoiceTTC = false) => {
    if (isInvoiceTTC) {
      return (Math.round(value * 20) / 20.0).toFixed(places);
    }
    return value.toFixed(places);
  };

  export const toCurrency = (value: number, currency = 'CHF') => {
    const formatter = new Intl.NumberFormat('de-CH', {
      style: 'currency',
      currency: currency,
    });

    return formatter.format(value);
  };

  export const nFormatter = (num: number, digits: number) => {
    const lookup = [
      {value: 1, symbol: ''},
      {value: 1e3, symbol: 'k'},
      {value: 1e6, symbol: 'M'},
      {value: 1e9, symbol: 'G'},
      {value: 1e12, symbol: 'T'},
      {value: 1e15, symbol: 'P'},
      {value: 1e18, symbol: 'E'}
    ];
    const regexp = /\.0+$|(?<=\.[0-9]*[1-9])0+$/;
    const item = lookup.slice().reverse().find(item => Math.abs(num) >= item.value);
    return item ? (num / item.value).toFixed(digits).replace(regexp, '').concat(item.symbol) : '0';
  };
}
